import { useMemo } from 'react';
import { useSettings } from 'context/SettingsContext';
import { getSettingsParams } from 'utils/helpers/settings/getSettingsParams';

const useSettingsParams = () => {
    const { settings } = useSettings();
    return useMemo(() => getSettingsParams(settings), [settings?.global?.params]);
};

export default useSettingsParams;
